<template>
  <div class="criterio-date-range">
    <span v-if="labelDate" class="criterio-subtitle">{{ labelDate }}</span>
    <v-row>
      <v-col class="py-0 pt-1" align="center">
        <date-picker
          outlined
          :date.sync="date"
          :min="minDate"
          :disabled="disabled"
          icon
          :append-icon="false"
          hide-details
          label="Data"
          class="default-input"
          @input="input"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue'
import { DateTime } from 'luxon'

export default {
  name: 'CriterioDate',
  components: {
    DatePicker,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    currentIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    initialValue: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: String,
      validator: (val) => ['futureOnly'].includes(val),
    },
  },
  data: () => ({
    date: null,
    labelDate: null,
  }),

  computed: {
    minDate() {
      return this.componentParams === 'futureOnly' ? DateTime.now().toFormat('yyyy-MM-dd') : null
    },
  },

  mounted() {
    this.formatInitialValues()
    this.validate(this.initialValue)
  },

  methods: {
    input() {
      let dateToSave = DateTime.fromISO(this.date).toFormat('yyyyMMdd')

      this.$emit('input', { currentValue: dateToSave, currentIndex: this.currentIndex })

      this.validate()
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    isValid() {
      return Boolean(this.date)
    },

    formatInitialValues() {
      if (typeof this.initialValue === 'string') {
        this.date = DateTime.fromFormat(this.initialValue, 'yyyyMMdd').toFormat('yyyy-MM-dd')
      } else {
        this.date = this.initialValue?.[0] ? DateTime.fromFormat(this.initialValue[0], 'yyyyMMdd').toFormat('yyyy-MM-dd') : null
      }
      this.labelDate = this.label ? this.label : null
    },
  },
}
</script>

<style lang="scss">
.criterio-date-range {
  .input-container {
    margin-right: 15px;
  }
}
</style>
